__turbopack_context__.v({
  "gridLogo": "wMt7sa_gridLogo",
  "portfolioSection": "wMt7sa_portfolioSection",
  "skillGrid": "wMt7sa_skillGrid",
  "skillsSection": "wMt7sa_skillsSection",
});
